import { template as template_e5db9b334a8b47ca8efb24ccc02eda4e } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { isTesting } from '@embroider/macros';
import RouteTemplate from 'ember-route-template';
import CardPrerender from '@cardstack/host/components/card-prerender';
interface ApplicationRouteSignature {
    Args: {
    };
}
const showCardPrerender = isTesting();
const ApplicationRouteComponent: TemplateOnlyComponent<ApplicationRouteSignature> = template_e5db9b334a8b47ca8efb24ccc02eda4e(`
    {{outlet}}

    {{! this is used to establish a prerenderer for browser-based indexing }}
    {{#if showCardPrerender}}
      <CardPrerender />
    {{/if}}
  `, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(ApplicationRouteComponent);
